import React from 'react';
import { Tag } from '@guildeducationinc/recess';
import { GetMemberProgramQuery } from 'src/graphqlTypes/catalogServiceTypes';
import { useRecommendations } from 'src/components/Providers/RecommendationsProvider';
import { Skeleton } from 'src/components/UserFacetSkeletonLoader';
import { isAffiliateProgram } from '@src/utilities/offeringHitsUtility';
import styles from './Tags.module.scss';

interface Props {
	loading?: boolean;
	program: GetMemberProgramQuery['memberProgram'];
}

export const Tags: React.FC<Props> = ({ loading: programDataLoading, program }) => {
	const { recommendationsData, recommendationsLoading } = useRecommendations();

	const isRecommended =
		recommendationsData?.recommendations.filter(rec => rec.id === program?.id)?.length > 0;

	return (
		<Skeleton dataLoading={recommendationsLoading && programDataLoading}>
			{!recommendationsLoading && isRecommended && (
				<Tag appearance='quiet' className={styles.tags} color='green' testid='recommended-tag'>
					Quiz recommended
				</Tag>
			)}
			{!programDataLoading && program?.featured && (
				<Tag appearance='quiet' className={styles.tags} color='blue' testid='featured-tag'>
					Employer featured program
				</Tag>
			)}
			{!programDataLoading && isAffiliateProgram(program) && (
				<Tag appearance='quiet' className={styles.tags} color='grey' testid='dpp-tag'>
					Direct Payment Program
				</Tag>
			)}
		</Skeleton>
	);
};
